export default {
    apiEndpoint: 'https://betterthanbelts.prismic.io/api/v2',
  
    linkResolver(doc, ctx) {
      return '/';
    }
  };